// src/js/reducers/index.js
import * as types from "../constants/action-types";

export default function timeLossReducer(state = [], action) {
    switch (action.type) {
       
        case types.LOGOUT:
            return []
        case types.CREATE_TIME_LOSS_SUCCESS:
            return [...state, Object.assign({}, action.code)];
        case types.UPDATE_TIME_LOSS_SUCCESS:
            return [...state.filter(code => code.timeLossId != action.code.timeLossId), Object.assign({}, action.code)];
        case types.GET_TIME_LOSS_SUCCESS:
            return [...state.filter(code => code.timeLossId != action.code.timeLossId), Object.assign({}, action.code)];
        case types.DELETE_TIME_LOSS_SUCCESS:
            return [...state.filter(code => code.timeLossId != action.code.timeLossId)];
        case types.LOAD_TIME_LOSS_SUCCESS:
           return action.codes;
        
        default:
            return state;
    };
};


